import React from "react";

function Spinner() {
  return (
    <div className="spinner-parent">
      <div className="spinner-border" role="status"></div>
    </div>
  );
}

export default Spinner;
